document.addEventListener("DOMContentLoaded", (event) => {
  const stockistItem = document.getElementById("stockist-item");
  if (stockistItem) {
    stockistItem.addEventListener("click", function () {
      window.open(
        "https://www.google.com/maps/dir/?api=1&amp;destination=1341%20Dandenong%20Rd%20Shop%20B114%2C%20Chadstone%20Shopping%20Centre%20Malvern%20East%20VIC%203148%20Australia",
        "_blank"
      );
    });
  }
});
